export const FACEBOOK = 'https://facebook.com/avalanchecanada'
export const INSTAGRAM = 'https://instagram.com/avalanchecanada'
export const TWITTER = 'https://twitter.com/avalancheca'
